export default "__VITE_ASSET__BoXZQYOb__"